if (!customElements.get('consent-video')) {
  customElements.define('consent-video', class extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.openChoices = () => window.OneTrust?.ToggleInfoDisplay?.();
      this.manageButton = this.querySelector('[data-consent-placeholder] button');
      this.manageButton.addEventListener('click', this.openChoices);
      window.addEventListener('OneTrustGroupsUpdated', this.update);
      window.addEventListener('consent.onetrust', this.update);
      window.addEventListener('pageshow', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.manageButton.removeEventListener('click', this.openChoices);
      window.removeEventListener('OneTrustGroupsUpdated', this.update);
      window.removeEventListener('consent.onetrust', this.update);
      window.removeEventListener('pageshow', this.update);
    }

    createFrame(autoplay) {
      const frame = this.querySelector('template:not([data-facade])').content.firstElementChild.cloneNode(true);
      const url = new URL(frame.dataset.src, window.location.href);
      if (autoplay) url.searchParams.set('autoplay', '1');
      frame.src = url.href;
      return frame;
    }

    play(button) {
      const frame = this.createFrame(true);
      button.replaceWith(frame);
      frame.focus();
    }

    update() {
      const allowed = window.OneTrust?.IsAlertBoxClosed?.() === true &&
        (window.OnetrustActiveGroups || '').split(',').includes('C0004');
      const placeholder = this.querySelector('[data-consent-placeholder]');
      const current = this.querySelector('iframe');
      const staleFacade = this.querySelector('[data-video-facade]');
      if (!allowed) {
        current?.remove();
        staleFacade?.remove();
        placeholder.hidden = false;
        return;
      }
      if (!current && !staleFacade) {
        const facadeTemplate = this.querySelector('template[data-facade]');
        if (facadeTemplate) {
          const button = facadeTemplate.content.firstElementChild.cloneNode(true);
          button.setAttribute('data-video-facade', '');
          // Poster loads from YouTube's image host only after consent, when the facade is created.
          const poster = button.querySelector('img[data-poster-src]');
          if (poster) poster.src = poster.dataset.posterSrc;
          button.addEventListener('click', () => this.play(button));
          this.appendChild(button);
        } else {
          this.appendChild(this.createFrame(false));
        }
      }
      placeholder.hidden = true;
    }
  });
}
